import { createFileRoute } from '@tanstack/react-router';

import { ClientExercisesListScreen } from '@/features/engagement/components/ClientExercisesListScreen';

export const Route = createFileRoute('/client/exercises/')({
  component: ClientExercisesRoute,
});

function ClientExercisesRoute() {
  return <ClientExercisesListScreen />;
}
